import { ShieldCheck, BadgeCheck, Award, Wrench } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Fully Insured" },
  { icon: BadgeCheck, label: "18th Edition Certified" },
  { icon: Award, label: "Domestic & Commercial" },
  { icon: Wrench, label: "Honest Hourly Rates" },
];

export const TrustBar = () => (
  <section
    data-testid="trust-banner"
    className="relative bg-[#0F0F0F] border-y border-white/5"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
      <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-14 pb-8 border-b border-white/5">
        <div className="text-[10px] tracking-[0.3em] text-[#A0AAB2] uppercase">
          Accredited &amp; Qualified
        </div>

        {/* NAPIT */}
        <div data-testid="napit-badge" className="flex items-center gap-3 group">
          <div className="relative w-14 h-14 flex items-center justify-center">
            <svg viewBox="0 0 56 56" className="absolute inset-0 w-full h-full">
              <polygon
                points="28,4 52,16 52,40 28,52 4,40 4,16"
                fill="none"
                stroke="#1E90FF"
                strokeWidth="2"
              />
              <polygon
                points="28,10 47,20 47,38 28,48 9,38 9,20"
                fill="none"
                stroke="#1E90FF"
                strokeWidth="0.5"
                opacity="0.5"
              />
            </svg>
            <span className="relative text-[#1E90FF] font-extrabold text-[11px] tracking-wider" style={{ fontFamily: "Outfit" }}>
              NAPIT
            </span>
          </div>
          <div className="leading-tight">
            <div className="text-white font-bold text-base tracking-wide" style={{ fontFamily: "Outfit" }}>
              NAPIT
            </div>
            <div className="text-[9px] text-[#A0AAB2] tracking-[0.2em] uppercase">
              Registered
            </div>
          </div>
        </div>

        <div className="h-12 w-px bg-white/10 hidden md:block" />

        {/* City & Guilds */}
        <div data-testid="city-and-guilds-badge" className="flex items-center gap-3 group">
          <div className="relative w-14 h-14 flex items-center justify-center">
            <svg viewBox="0 0 56 56" className="absolute inset-0 w-full h-full">
              <circle cx="28" cy="28" r="25" fill="none" stroke="#1E90FF" strokeWidth="2" />
              <circle cx="28" cy="28" r="20" fill="none" stroke="#1E90FF" strokeWidth="0.5" opacity="0.5" />
              <path d="M 16 28 L 40 28 M 28 16 L 28 40" stroke="#1E90FF" strokeWidth="0.5" opacity="0.4" />
            </svg>
            <span className="relative text-[#1E90FF] font-extrabold text-[10px]" style={{ fontFamily: "Outfit" }}>
              C&amp;G
            </span>
          </div>
          <div className="leading-tight">
            <div className="text-white font-bold text-base tracking-wide" style={{ fontFamily: "Outfit" }}>
              City &amp; Guilds
            </div>
            <div className="text-[9px] text-[#A0AAB2] tracking-[0.2em] uppercase">
              Qualified
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8">
        {ITEMS.map(({ icon: Icon, label }) => (
          <div
            key={label}
            data-testid={`trust-${label.toLowerCase().replace(/\s/g, "-")}`}
            className="flex items-center gap-3 group justify-center md:justify-start"
          >
            <Icon className="w-5 h-5 text-[#1E90FF] shrink-0" strokeWidth={1.5} />
            <span className="text-sm text-[#A0AAB2] group-hover:text-white transition-colors tracking-wide">
              {label}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
